<header-style-menu-lateral></header-style-menu-lateral>

<main>
    <div class="container-fluid">
        <div class="col-dynamic-width flex-lg-nowrap row">
            <div class="col-12 col-lg-auto col-lateral">
                <div class="lateral-menu-bar wrap-main-module" id="lateral-menu-bar">
                    <div class="lateral-menu-wrap-content">

                        <button (click)="onClickToogleMenu($event)" type="button"
                            class="mgn-rigth-12 btn btn-action-lateral-menu btn-light btn-sm collapse-lateral-menu d-lg-block d-none lateral-menubar-toggler"><i
                                class="pj-ico pj-ico-flecha-abajo-usuario"></i>
                        </button>

                        <button (click)="onClickCloseMenu($event)" type="button"
                            class="mgn-rigth-12 btn btn-light btn-sm btn-action-lateral-menu close-lateral-menu d-lg-none"
                            title="Cerrar">&times;</button>


                        <div class="overflow-y-degraded-border top"></div>


                        <div class="lateral-menu-main-content" id="lateral-menu-content">
                            <div class="module-section">
                                <h4 class="module-section-heading">Atracción</h4>
                                <ul class="menu-bar-main-module">
                                    <li *appHasAccessModule="profile_access_module.employer_profile"
                                        class="menu-item-main-module"
                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.edit] | isActiveRoute : currentTs}">
                                        <a [routerLink]="['/',path_module_employer.module,path_module_employer.edit]">
                                            <div class="menu-item-frame">
                                                <div><i class="pj-ico pj-ico-institucion"></i>
                                                </div>
                                                <div>
                                                    Perfil institucional
                                                </div>
                                            </div>
                                        </a>
                                    </li>

                                    <li class="menu-item-main-module"
                                        [ngClass]="{'active': [path_module_public.salaries] | isActiveRoute : currentTs}">
                                        <a [routerLink]="['/',path_module_public.salaries]">
                                            <div class="menu-item-frame">
                                                <div><i class="pj-ico pj-ico-salarios"></i>
                                                </div>
                                                <div>
                                                    Brújula Salarial
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="module-section">
                                <h4 class="module-section-heading">Reclutamiento y selección</h4>
                                <ul class="menu-bar-main-module">
                                    <li *appHasAccessModule="profile_access_module.employer_job"
                                        class="menu-item-main-module compact-mode-menu-item "
                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.job_list] | isActiveRoute : currentTs}">
                                        <a
                                            [routerLink]="['/',path_module_employer.module, path_module_employer.job_list]">
                                            <div class="menu-item-frame">
                                                <div><i class="pj-ico pj-ico-anuncios-2"></i>
                                                </div>
                                                <div class="tag-menu-item">
                                                    Anuncios
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <li *appHasAccessModule="profile_access_module.search_talent"
                                        class="menu-item-main-module compact-mode-menu-item"
                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.search_talent] | isActiveRoute : currentTs}">
                                        <a
                                            [routerLink]="['/',path_module_employer.module, path_module_employer.search_talent]">
                                            <div class="menu-item-frame">
                                                <div>
                                                    <i class="pj-ico pj-ico-base-datos"></i>
                                                </div>
                                                <div class="tag-menu-item">
                                                    Buscar talento
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <li *appHasAccessModule="profile_access_module.employer_psycho_interview"
                                        class="menu-item-main-module compact-mode-menu-item"
                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.psycho_interview] | isActiveRoute : currentTs}">
                                        <a
                                            [routerLink]="['/',path_module_employer.module, path_module_employer.psycho_interview]">
                                            <div class="menu-item-frame">
                                                <div>
                                                    <i class="pj-ico pj-ico-entrevista-sicolaboral"></i>
                                                </div>
                                                <div class="tag-menu-item">
                                                    Evaluaciones psicolaborales
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <li *appHasAccessModule="profile_access_module.employer_certificates"
                                        class="menu-item-main-module"
                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.certificates] | isActiveRoute : currentTs}">
                                        <span class="badge badge-primary">Beta</span>
                                        <a
                                            [routerLink]="['/',path_module_employer.module, path_module_employer.certificates]">
                                            <div class="menu-item-frame">
                                                <div><i class="pj-ico pj-ico-documentacion"></i>
                                                </div>
                                                <div class="tag-menu-item">
                                                    Certificados
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <ng-template *ngIf="!(+userService.getUserEventFlag === 0)"
                                [appHasActivateModule]="profile_access_module.employer_complaint_channel"
                                [appViewElse]="elseViewComplaintChannel">

                                <ng-template [appHasAccessModule]="profile_access_module.employer_complaint_channel"
                                    [hasActivateModule]="profile_access_module.employer_complaint_channel">

                                    <div class="module-section">
                                        <h4 class="module-section-heading">Canal de denuncias</h4>
                                        <ul class="menu-bar-main-module">
                                            <li class="menu-item-main-module"
                                                [ngClass]="{'active': [path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.complaint_documentation] | isActiveRoute : currentTs}">
                                                <a
                                                    [routerLink]="['/',path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.complaint_documentation]">
                                                    <div class="menu-item-frame">
                                                        <div><i class="pj-ico pj-ico-documentacion"></i>
                                                        </div>
                                                        <div class="tag-menu-item">
                                                            Documentación
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                            <li class="menu-item-main-module"
                                                [ngClass]="{'active': [path_module_employer.module, path_module_employer.module_complaint_channel,  path_module_employer.complaint_protocol] | isActiveRoute : currentTs}">
                                                <a
                                                    [routerLink]="['/',path_module_employer.module, path_module_employer.module_complaint_channel,  path_module_employer.complaint_protocol]">
                                                    <div class="menu-item-frame">
                                                        <div><i class="pj-ico pj-ico-check-list"></i>
                                                        </div>
                                                        <div class="tag-menu-item">
                                                            Protocolos
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>

                                            <li *ngIf="userService.isEmployer()" class="menu-item-main-module"
                                                [ngClass]="{'active': [path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.complaints] | isActiveRoute : currentTs}">
                                                <a
                                                    [routerLink]="['/',path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.complaints]">
                                                    <div class="menu-item-frame">
                                                        <div><i class="pj-ico pj-ico-evaluaciones"></i>
                                                        </div>
                                                        <div class="tag-menu-item">
                                                            Denuncias
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>

                                            <li class="menu-item-main-module menu-multilevel-item" [ngClass]="{
                                                'open': isSubmenuOpen }">

                                                <a href="#" data-toggle="collapse" data-target="#submenu"
                                                    (click)="toggleSubmenu($event)">
                                                    <div class="menu-item-frame">
                                                        <div><i class="pj-ico pj-ico-ajustes"></i></div>
                                                        <div class="tag-menu-item">Configuración</div>
                                                    </div>
                                                </a>
                                                <ul id="submenu" class="menu-multilevel-group collapse" [ngClass]="{
                                                    'show': ([path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.notifications] | isActiveRoute : currentTs) ||
                                                            ([path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.complaint_configuration] | isActiveRoute : currentTs)
                                                  }">
                                                    <li class="menu-item-main-module"
                                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.module_complaint_channel,  path_module_employer.notifications] | isActiveRoute : currentTs}">
                                                        <a
                                                            [routerLink]="['/', path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.notifications]">Notificaciones</a>
                                                    </li>
                                                    <li class="menu-item-main-module"
                                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.module_complaint_channel,  path_module_employer.complaint_configuration] | isActiveRoute : currentTs}">
                                                        <a
                                                            [routerLink]="['/', path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.complaint_configuration]">Personalización
                                                            de formulario</a>
                                                    </li>
                                                </ul>
                                            </li>

                                        </ul>
                                    </div>
                                </ng-template>
                            </ng-template>
                            <ng-template #elseViewComplaintChannel>
                                <div class="module-section">
                                    <h4 class="module-section-heading">Canal de denuncias</h4>
                                    <ul class="menu-bar-main-module">
                                        <li class="menu-item-main-module"
                                            [ngClass]="{'active': [path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.complaint_channel] | isActiveRoute : currentTs}">
                                            <span class="badge badge-primary">Nuevo</span>
                                            <a
                                                [routerLink]="['/',path_module_employer.module, path_module_employer.module_complaint_channel, path_module_employer.complaint_channel]">
                                                <div class="menu-item-frame">
                                                    <div><i class="pj-ico pj-ico-evaluaciones"></i>
                                                    </div>
                                                    <div class="tag-menu-item">
                                                        Denuncias
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </ng-template>


                            <div class="module-section"
                                *appHasAccessModule="profile_access_module.employer_certificates">
                                <h4 class="module-section-heading">Mantenedores</h4>
                                <ul class="menu-bar-main-module">

                                    <li class="menu-item-main-module"
                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.manager, path_module_employer.manager_team] | isActiveRoute : currentTs}">
                                        <a
                                            [routerLink]="['/',path_module_employer.module, path_module_employer.manager, path_module_employer.manager_team]">
                                            <div class="menu-item-frame">
                                                <div><i class="pj-ico pj-ico-equipos-2"></i>
                                                </div>
                                                <div class="tag-menu-item">
                                                    Equipo
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>




                            <div class="module-section">
                                <h4 class="module-section-heading">Configuración</h4>
                                <ul class="menu-bar-main-module">
                                    <li class="menu-item-main-module"
                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.users] | isActiveRoute : currentTs}">
                                        <a [routerLink]="['/',path_module_employer.module, path_module_employer.users]">
                                            <div class="menu-item-frame">
                                                <div><i class="pj-ico pj-ico-usuarios-2"></i>
                                                </div>
                                                <div class="tag-menu-item">
                                                    Usuarios
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="menu-item-main-module"
                                        [ngClass]="{'active': [path_module_employer.module, path_module_employer.membership_info] | isActiveRoute : currentTs}">
                                        <a
                                            [routerLink]="['/',path_module_employer.module, path_module_employer.membership_info]">
                                            <div class="menu-item-frame">
                                                <div><i class="pj-ico pj-ico-bd-usuario-profejobs"></i>
                                                </div>
                                                <div class="tag-menu-item">
                                                    Cuenta
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <li class="menu-item-main-module"><a href="files/profejobs-manual.pdf"
                                            target="_blank">
                                            <div class="menu-item-frame">
                                                <div><i class="pj-ico pj-ico-manual"></i>
                                                </div>
                                                <div class="tag-menu-item">
                                                    Manual
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="overflow-y-degraded-border bottom"></div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-dynamic col-lg-10">
                <div class="wrap-main-module">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</main>

<app-footer-style-default></app-footer-style-default>